// extracted by mini-css-extract-plugin
export default {"bell":"notify-button_bell__I5s0o"};